export const REQUIRED_INFORMATION = 'Informação obrigatória.';
export const INVALID_DATE_SMALL = 'Data inválida.';
export const INVALID_DATE_BIG = 'Esta data não é válida.';
export const INVALID_CPF = 'Este CPF não é válido.';
export const REQUIRED_SELECTION = 'Seleção obrigatória.';
export const INVALID_PHONE = 'Este telefone não é válido.';
export const INVALID = 'Inválido.';
export const INVALID_NUMBER = 'Este número não é válido.';
export const INVALID_NAME = 'Insira o nome completo.';
